export default "$ yarn serve\n// OR\n$ npm run serve\n";